// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --border: solid 1px var(--colors-greyLight);
}

.app-main-Authenticated-Header-___Header-module__container {
  position: relative;
  z-index: 2;
  max-height: 40px;
  height: 40px;
}

.app-main-Authenticated-Header-___Header-module__header {
  align-items: center;
  background-color: #fff;
  box-shadow: 2px 0px 9px -4px rgba(0, 0, 0, 0.5);
  display: flex;
  z-index: 2;
  position: relative;
  max-height: 40px;
  height: 40px;
}

.app-main-Authenticated-Header-___Header-module__burgerButton {
  padding-left: 15px;
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
}

.app-main-Authenticated-Header-___Header-module__userAccount {
  margin-right: 20px;
}

.app-main-Authenticated-Header-___Header-module__name {
  display: flex;
  position: relative;
  padding: 0 20px;
  font-size: 24px;
}

.app-main-Authenticated-Header-___Header-module__name .app-main-Authenticated-Header-___Header-module__nameStart {
    font-family: 'ralewaybold';
  }

.app-main-Authenticated-Header-___Header-module__logo {
  margin-right: 5px;
  height: 35px;
}

.app-main-Authenticated-Header-___Header-module__logout {
  border-left: solid 1px var(--colors-grey);
  padding-left: 10px;
  margin-left: 10px;
}

/**___________________________________________________________
 *
 *                          NAV
 * ___________________________________________________________
 */

.app-main-Authenticated-Header-___Header-module__nav {
  flex: 1;
}

.app-main-Authenticated-Header-___Header-module__iconsNav {
  display: flex;
  align-items: flex-end;
  border-left: var(--border);
  border-right: var(--border);
  /* margin-bottom: 10px; */
  margin-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.app-main-Authenticated-Header-___Header-module__iconsNav.app-main-Authenticated-Header-___Header-module__hasUnreadNotifs {
    padding-top: 5px;
  }

.app-main-Authenticated-Header-___Header-module__listV {
  display: flex;
}

.app-main-Authenticated-Header-___Header-module__listH {
  position: absolute;
  display: none;
  border-bottom: var(--border);
  border-left: var(--border);
  border-right: var(--border);
  min-width: 150px;
  box-shadow: 1px 2px 5px 1px #ddd;
}

.app-main-Authenticated-Header-___Header-module__listH .app-main-Authenticated-Header-___Header-module__item {
    border-top: var(--border);
  }

.app-main-Authenticated-Header-___Header-module__listH .app-main-Authenticated-Header-___Header-module__linkItem {
    padding: 10px 15px;
  }

.app-main-Authenticated-Header-___Header-module__item {
  transition: background-color 0.1s;
}

.app-main-Authenticated-Header-___Header-module__item > .app-main-Authenticated-Header-___Header-module__linkItem {
    background-color: #fff;
    color: var(--colors-black);
    text-decoration: none;
    text-transform: uppercase;
    font-size: 14px;
    padding: 15px 15px;
    display: block;
    transition: color 0.1s;
  }

.app-main-Authenticated-Header-___Header-module__item > .app-main-Authenticated-Header-___Header-module__linkItem:hover,
    .app-main-Authenticated-Header-___Header-module__item > .app-main-Authenticated-Header-___Header-module__linkItem.app-main-Authenticated-Header-___Header-module__active {
      background-color: var(--colors-mainColor);
      color: #fff;
    }

.app-main-Authenticated-Header-___Header-module__item:hover .app-main-Authenticated-Header-___Header-module__listH {
      display: block;
    }

.app-main-Authenticated-Header-___Header-module__button {
  height: 40px;
  width: 40px;
}

.app-main-Authenticated-Header-___Header-module__buttonIcon {
  font-size: 18px;
}
.app-main-Authenticated-Header-___Header-module__nameStart {
  font-family: 'ralewaybold';
}
`, "",{"version":3,"sources":["webpack://./app/main/Authenticated/Header/Header.module.scss"],"names":[],"mappings":"AAAA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,+CAA+C;EAC/C,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;AAIjB;;AAHE;IACE,0BAA0B;EAC5B;;AAGF;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE;;AAEF;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AAItB;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;AAOlC;;AANE;IACE,yBAAyB;EAC3B;;AACA;IACE,kBAAkB;EACpB;;AAGF;EACE,iCAAiC;AAqBnC;;AApBE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,sBAAsB;EAMxB;;AALE;;MAEE,yCAAyC;MACzC,WAAW;IACb;;AAGA;MACE,cAAc;IAChB;;AAIJ;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[":root {\n  --border: solid 1px var(--colors-greyLight);\n}\n\n.container {\n  position: relative;\n  z-index: 2;\n  max-height: 40px;\n  height: 40px;\n}\n\n.header {\n  align-items: center;\n  background-color: #fff;\n  box-shadow: 2px 0px 9px -4px rgba(0, 0, 0, 0.5);\n  display: flex;\n  z-index: 2;\n  position: relative;\n  max-height: 40px;\n  height: 40px;\n}\n\n.burgerButton {\n  padding-left: 15px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 100%;\n}\n\n.userAccount {\n  margin-right: 20px;\n}\n\n.name {\n  display: flex;\n  position: relative;\n  padding: 0 20px;\n  font-size: 24px;\n  .nameStart {\n    font-family: 'ralewaybold';\n  }\n}\n\n.logo {\n  margin-right: 5px;\n  height: 35px;\n}\n\n.logout {\n  border-left: solid 1px var(--colors-grey);\n  padding-left: 10px;\n  margin-left: 10px;\n}\n\n/**___________________________________________________________\n *\n *                          NAV\n * ___________________________________________________________\n */\n\n.nav {\n  flex: 1;\n}\n\n.iconsNav {\n  display: flex;\n  align-items: flex-end;\n  border-left: var(--border);\n  border-right: var(--border);\n  /* margin-bottom: 10px; */\n  margin-right: 10px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  &.hasUnreadNotifs {\n    padding-top: 5px;\n  }\n}\n\n.listV {\n  display: flex;\n}\n\n.listH {\n  position: absolute;\n  display: none;\n  border-bottom: var(--border);\n  border-left: var(--border);\n  border-right: var(--border);\n  min-width: 150px;\n  box-shadow: 1px 2px 5px 1px #ddd;\n  .item {\n    border-top: var(--border);\n  }\n  .linkItem {\n    padding: 10px 15px;\n  }\n}\n\n.item {\n  transition: background-color 0.1s;\n  > .linkItem {\n    background-color: #fff;\n    color: var(--colors-black);\n    text-decoration: none;\n    text-transform: uppercase;\n    font-size: 14px;\n    padding: 15px 15px;\n    display: block;\n    transition: color 0.1s;\n    &:hover,\n    &.active {\n      background-color: var(--colors-mainColor);\n      color: #fff;\n    }\n  }\n  &:hover {\n    .listH {\n      display: block;\n    }\n  }\n}\n\n.button {\n  height: 40px;\n  width: 40px;\n}\n\n.buttonIcon {\n  font-size: 18px;\n}\n.nameStart {\n  font-family: 'ralewaybold';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-main-Authenticated-Header-___Header-module__container`,
	"header": `app-main-Authenticated-Header-___Header-module__header`,
	"burgerButton": `app-main-Authenticated-Header-___Header-module__burgerButton`,
	"userAccount": `app-main-Authenticated-Header-___Header-module__userAccount`,
	"name": `app-main-Authenticated-Header-___Header-module__name`,
	"nameStart": `app-main-Authenticated-Header-___Header-module__nameStart`,
	"logo": `app-main-Authenticated-Header-___Header-module__logo`,
	"logout": `app-main-Authenticated-Header-___Header-module__logout`,
	"nav": `app-main-Authenticated-Header-___Header-module__nav`,
	"iconsNav": `app-main-Authenticated-Header-___Header-module__iconsNav`,
	"hasUnreadNotifs": `app-main-Authenticated-Header-___Header-module__hasUnreadNotifs`,
	"listV": `app-main-Authenticated-Header-___Header-module__listV`,
	"listH": `app-main-Authenticated-Header-___Header-module__listH`,
	"item": `app-main-Authenticated-Header-___Header-module__item`,
	"linkItem": `app-main-Authenticated-Header-___Header-module__linkItem`,
	"active": `app-main-Authenticated-Header-___Header-module__active`,
	"button": `app-main-Authenticated-Header-___Header-module__button`,
	"buttonIcon": `app-main-Authenticated-Header-___Header-module__buttonIcon`
};
export default ___CSS_LOADER_EXPORT___;
